module.exports = __webpack_public_path__ + "img/daijinquan.07fcbfaf.png";